import { ERR_GENERIC, ERR_GENERIC_LATER, } from '../../constants/response-error-messages';
import { FULFILLMENT_TYPE } from '../../constants/status';
import { pushEventInfo, pushEventInfoWithFulfillment } from '../analytics';
// ============================================
// PRO SITE INSTRUCTIONS ANALYTICS
// ============================================
/**
 * 1.1 - "Edit" link Render
 *
 * Track that the user can see the "Edit" link next to Delivery Instructions
 * for Pro Site Instructions (DFS) feature.
 *
 */
export var catchProSiteInstructionsEditLinkDisplayed = function () {
    pushEventInfo({
        category: { primaryCategory: 'button submission' },
        eventInfo: { eventName: 'my account settings' },
        myAccount: {
            settings: 'purchase history: order details: pro edit link displayed',
        },
    });
};
/**
 * 1.2 - "Edit" link Clicks
 *
 * Track that the user clicked the "edit" button link near delivery instructions
 * and viewed the edit delivery instructions overlay for Pro Site Instructions (DFS).
 *
 */
export var catchProSiteInstructionsOverlayOpened = function () {
    pushEventInfo({
        category: { primaryCategory: 'overlay' },
        eventInfo: { eventName: 'pro site delivery instructions' },
    });
};
/**
 * 1.3 - "Edit" Delivery Instructions Complete
 *
 * Track that the user clicked the save changes button, sees the survey and completed
 * the edit delivery process for Pro Site Instructions (DFS).
 *
 */
export var catchProSiteInstructionsUpdated = function () {
    pushEventInfo({
        category: { primaryCategory: 'button submission' },
        eventInfo: { eventName: 'my account settings' },
        myAccount: {
            settings: 'purchase history: order details: pro site delivery instructions: save changes',
        },
    });
};
/**
 * 1.4 - Post Page Load Error Tracking
 *
 * Track errors that occur during the pro site instructions process WITHOUT a page load.
 *
 */
export var catchProSiteInstructionsPostPageLoadError = function (errorCode) {
    pushEventInfo({
        category: { primaryCategory: 'error' },
        eventInfo: {
            eventName: 'post page error',
            error: [
                {
                    type: 'advisory',
                    displayType: 'inline',
                    pageSection: 'pro site delivery instructions',
                    message: ERR_GENERIC.message,
                    code: errorCode || 'n/a',
                },
            ],
        },
    });
};
// ============================================
// STANDARD DELIVERY INSTRUCTIONS ANALYTICS
// ============================================
// 1.1 Edit Delivery Instructions Overlay
export var catchEditDeliveryInstructionsButtonPress = function () {
    pushEventInfo({
        category: { primaryCategory: 'overlay' },
        eventInfo: {
            eventName: 'purchase history: order details: edit delivery instructions',
        },
    });
};
var getFulfillmentTypesPresent = function (fulfillmentType) {
    var sth = false;
    var boss = false;
    var bopis = false;
    var bodfs = false;
    var dfs = false;
    var appliance = false;
    var misc = false;
    switch (fulfillmentType) {
        case FULFILLMENT_TYPE.STH:
            sth = true;
            break;
        case FULFILLMENT_TYPE.BODFS:
            bodfs = true;
            break;
        case FULFILLMENT_TYPE.APPLIANCE:
            appliance = true;
            break;
        case FULFILLMENT_TYPE.DFS:
            dfs = true;
            break;
        case FULFILLMENT_TYPE.BOPIS:
            bopis = true;
            break;
        case FULFILLMENT_TYPE.BOSS:
            boss = true;
            break;
        default:
            misc = true;
            break;
    }
    return {
        sth: sth,
        bodfs: bodfs,
        appliance: appliance,
        dfs: dfs,
        bopis: bopis,
        boss: boss,
        misc: misc,
    };
};
// 1.2 Order Details Delivery Instructions Updated
export var catchEditDeliveryInstructionsUpdated = function (fulfillmentType) {
    var fulfillmentTypes = getFulfillmentTypesPresent(fulfillmentType);
    var settings = "orders:sth:".concat(fulfillmentTypes.sth ? 'y' : 'n', "|boss:").concat(fulfillmentTypes.boss ? 'y' : 'n', "|bopis:").concat(fulfillmentTypes.bopis ? 'y' : 'n', "|bodfs:").concat(fulfillmentTypes.bodfs ? 'y' : 'n', "|appl:").concat(fulfillmentTypes.appliance ? 'y' : 'n', "|unknown:").concat(fulfillmentTypes.misc || fulfillmentTypes.dfs ? 'y' : 'n');
    pushEventInfoWithFulfillment({
        category: { primaryCategory: 'button submission' },
        eventInfo: { eventName: 'my account settings' },
        myAccount: {
            settings: 'purchase history: order details: edit delivery instructions updated',
        },
        fulfillmentType: settings,
    });
};
// 1.4 Post Page Load Error Tracking
export var catchEditDeliveryInstructionsPostPageLoadError = function (errorCode) {
    pushEventInfo({
        category: { primaryCategory: 'error' },
        eventInfo: {
            eventName: 'post page error',
            error: [
                {
                    type: 'advisory',
                    displayType: 'inline',
                    pageSection: 'order details>edit delivery instructions',
                    message: ERR_GENERIC_LATER.message,
                    code: errorCode,
                },
            ],
        },
    });
};
// 1.5 Order Delivery Instructions Updated Button Submission
export var catchButtonDisplayEvent = function () {
    pushEventInfo({
        category: { primaryCategory: 'button submission' },
        eventInfo: {
            eventName: 'my account settings',
        },
        myAccount: {
            settings: 'purchase history: order details: edit delivery instructions button displayed',
        },
    });
};
